// detectImageType(buffer)
// This function takes an image buffer and returns the corresponding MIME type (e.g., 'image/png', 'image/jpeg').
// It checks the first few bytes (the header) of the file to detect its format based on known signatures.
// If the format is not recognized, it safely falls back to 'application/octet-stream'.

export default function detectImageType(buffer) {
  const header = buffer.slice(0, 8);
  const asString = buffer.toString("utf8", 0, 5);
  if (asString.startsWith("<svg")) return "image/svg+xml";
  if (header[0] === 0x89 && header[1] === 0x50 && header[2] === 0x4E && header[3] === 0x47) return "image/png";
  if (header[0] === 0xFF && header[1] === 0xD8 && header[2] === 0xFF) return "image/jpeg";
  if (header[0] === 0x47 && header[1] === 0x49 && header[2] === 0x46) return "image/gif";
  if (header[0] === 0x52 && header[1] === 0x49 && header[2] === 0x46 && header[3] === 0x46 &&
      buffer.toString("utf8", 8, 12) === "WEBP") return "image/webp";
  return "application/octet-stream"; // fallback seguro
}